import Log from "./components/Log";
import ShortcutLink from "../shared/components/ShortcutLink";
import { FC, useState } from "react";
import {
    Box,
    CircularProgress,
    Stack,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Table } from "@mui/material";
import { TableCell } from "@mui/material";
import { Typography } from "@mui/material";
import { FilterQueryParams, PAGINATION_OPTIONS } from "src/utils/other";
import { useSystemLogsList } from "./hooks/useSystemLogsList";
import { useNavigate } from "react-router";
import { PATH_USERS } from "src/routes/paths";
import { fDate, fTime } from "src/utils/formatTime";
import NoDataBox from "../shared/components/NoData";

interface OwnProps {
    filters: FilterQueryParams;
}
const SystemLogsList: FC<OwnProps> = ({ filters }) => {
    const navigate = useNavigate();
    const [page, setPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const { t } = useTranslation();
    const { data: systemLogs, isLoading, isError } = useSystemLogsList(page, rowsPerPage, filters);

    const getEntityShortName = (entity: string) => {
        const splited = entity.split("\\");

        return splited[splited.length - 1];
    };

    return !isLoading && (isError || systemLogs?.count === 0) ? (
        <NoDataBox />
    ) : !isLoading && systemLogs?.data && systemLogs?.data.length > 0 ? (
        <Box sx={{ pt: 2 }}>
            <TableContainer>
                <Table sx={{ minWidth: 900 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t("systemLogs.list.dateTime")}</TableCell>
                            <TableCell>{t("systemLogs.list.user")}</TableCell>
                            <TableCell>{t("systemLogs.list.event")}</TableCell>
                            <TableCell>{t("systemLogs.list.action")}</TableCell>
                            <TableCell>{t("systemLogs.list.log")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {systemLogs?.data?.map((log) => (
                            <TableRow key={log.id}>
                                <TableCell>
                                    <Stack>
                                        {log.createdAt && (
                                            <>
                                                <Typography variant="body2">
                                                    {fDate(log.createdAt)}
                                                </Typography>
                                                <Typography variant="small">
                                                    {fTime(log.createdAt)}
                                                </Typography>
                                            </>
                                        )}
                                    </Stack>
                                </TableCell>
                                <TableCell>
                                    <Stack>
                                        <Typography variant="body2">
                                            {log.companyUserFullName}
                                            <ShortcutLink
                                                onClick={() => {
                                                    navigate(
                                                        PATH_USERS + `?id=${log.companyUserId}`
                                                    );
                                                }}
                                            />
                                        </Typography>
                                    </Stack>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ color: "primary.main" }}>
                                        {t(
                                            "systemLogs.list.objectType." +
                                                getEntityShortName(log.entityType)
                                        )}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    {t("systemLogs.list.operationType" + log.operationType)}
                                </TableCell>
                                <TableCell>
                                    <Log log={log} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {!!systemLogs?.count && (
                <TablePagination
                    labelRowsPerPage={t("shared.rowsPerPage")}
                    rowsPerPageOptions={PAGINATION_OPTIONS}
                    component="div"
                    count={systemLogs.count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(_, p) => setPage(p)}
                    onRowsPerPageChange={(e) => setRowsPerPage(parseInt(`${e.target.value}`))}
                />
            )}
        </Box>
    ) : (
        <Box sx={{ p: 3 }}>
            <CircularProgress />
        </Box>
    );
};

export default SystemLogsList;
